import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";
import { Navigate } from "src/router";
import { lazyNamed } from "src/utils/lazy-named";

const SyncNotificationOverrides = lazyNamed(
  () =>
    import(
      "src/components/notification-channels/default-notification-overrides"
    ),
  "SyncNotificationOverrides",
);
const Recipients = lazyNamed(() => import("./recipients"), "Recipients");
const Alerts = lazyNamed(() => import("./alerts"), "Alerts");
const WorkspaceJourneyAlerts = lazyNamed(
  () => import("./global-journey-alerts"),
  "WorkspaceJourneyAlerts",
);
const alertingLayoutImport = () => import("./layout");
const Layout = lazyNamed(alertingLayoutImport, "Layout");
const PagerDutyForm = lazyNamed(
  () => import("./recipients/components/pagerduty-form"),
  "PagerDutyForm",
);
const AdvancedAlertingSplashPage = lazyNamed(
  () => import("src/components/resource-alert-triggers/splash-page"),
  "AdvancedAlertingSplashPage",
);

export const preloads: RoutePreload[] = [["/alerting", alertingLayoutImport]];

export const routes: RouteObject[] = [
  {
    path: "alerting",
    spacesAccess: "hidden-from-limited-view",
    element: <Layout />,
    children: [
      {
        index: true,
        spacesAccess: "hidden-from-limited-view",
        element: <Navigate to="alerts" />,
      },
      {
        path: "recipients",
        spacesAccess: "hidden-from-limited-view",
        element: <Recipients />,
        children: [
          {
            path: "pagerduty/manage",
            spacesAccess: "hidden-from-limited-view",
            element: <PagerDutyForm />,
          },
        ],
      },
      {
        path: "overrides",
        spacesAccess: "hidden-from-limited-view",
        element: <SyncNotificationOverrides />,
      },
      {
        path: "alerts",
        spacesAccess: "hidden-from-limited-view",
        element: <Alerts />,
      },
      {
        path: "journeys",
        spacesAccess: "hidden-from-limited-view",
        element: <WorkspaceJourneyAlerts />,
      },
    ],
  },
  {
    path: "alerting/enable",
    spacesAccess: "hidden-from-limited-view",
    element: <AdvancedAlertingSplashPage />,
  },
];
